<template>
  <div id="app">
    <!-- <pre class="result">{{ value }}</pre> -->
    <treeselect :appendToBody="true"  noOptionsText="沒有数据" :open-on-click="openOnClick" :options="options" :disable-branch-nodes="disableBranchBodes" :show-count="true" :multiple="multiple" :disabled="disabled" :searchable="searchable" @select="nodeSelect" @input="inputclear" :default-expand-level="0" :placeholder="placeholder" v-model="value" />
  </div>
</template>
<script>
// import the component
import Treeselect from '@riophae/vue-treeselect'
// import the styles
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
// import opData from '../../../static/api/select-tree2.json'
export default {
  // register the component
  name: 'Tag-Select',
  props: {
    tData: Object,
  },
  components: { Treeselect },
  data() {
    return {
      value: null,
      options: this.tData === undefined ? [] : this.tData.data, //this.getTreeData(),
      treeMultiple: true,
      openOnClick: true,
      multiple: false,
      disabled: this.tDisable===undefined?false:this.tDisable,
      appendToBody: false,
      disableBranchBodes: false,
      searchable: false,
      placeholder: "请选择",
    }
  },
  methods: {
    getTreeData() {
      //console.log("json:"+this.tData.data)
      return this.tData.data
      //return opData
    },
    nodeSelect(node) {
      this.$emit('tag-Select', node)
    },
    inputclear(value) {
      //console.log(value)
      if (value === undefined) {
        this.$emit('onClearText')
      }
    },
    bindData(node) {
      //console.log("bindData...")
      this.options = node.data
      this.placeholder = node.placeholder
      this.searchable = node.searchable
    },
    bindDataTag(node, status) {
       // console.log("bindDataTag...")
       // console.log("status:"+status+",node.length:"+node.length)

      if (node.length > 0) {
        this.options = node
        if(status){
           this.setShowValue(node[0].id)
        }else{
          this.setShowValue(null)
        }
        this.disabled = status
      } else {
        this.options = []
        this.disabled = status
        this.value=null

      }


      // if (node.length === 1) {
      //   this.options = node
      //   this.setShowValue(node[0].id)
      //   this.disabled = status
      // } else {
      //   this.options = node
      //   this.disabled = false
      //   //this.setShowValue=['']
      // }


      // this.placeholder=node.placeholder
      // this.searchable=node.searchable

    },
    setShowValue(value) {
      //console.log("value:" + value)
      this.value = value
    },

  },
  mounted() {
    // console.log("child mounted")
    // console.log(this.tData.data)
    // this.options = this.tData.data
  },
  watch: {
    tData: {
      handler(val, oldVal) {
        //console.log("tag-Select...")
        //console.log(tData)
      }
    }
    // multiple(newValue) {
    //   if (newValue) {
    //     this.value = this.value ? [ this.value ] : []
    //   } else {
    //     this.value = this.value[0]
    //   }
    // },
  },

}

</script>
